import Text from '@/components/text';
import { Box, Stack } from '@mui/material';
import { startCase } from 'lodash';
import { FC } from 'react';

interface Props {
  label: string;
  value: string;
}

const ToolbarInfoRow: FC<Props> = ({ label, value }) => {
  const hasValue = !!value;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Box flexGrow={1}>
        <Text size="x-small" bold>
          {label}:
        </Text>
      </Box>
      <Box>
        <Text size="x-small">{hasValue ? startCase(value) : 'N/A'}</Text>
      </Box>
    </Stack>
  );
};

export default ToolbarInfoRow;
